import { createComponent } from '@carvana/merch-components';

export const CondensedHeroWrapper = createComponent('div', {
  className: `flex
      gap-xl
      px-2xl
      pb-2xl
      pt-xl
      shadow-[0px_8px_28px_0px_rgba(36,_41,_46,_0.04),0px_4px_8px_0px_rgba(36,_41,_46,_0.08)]
      sm:ml-2xl
      md:ml-0
      md:gap-3xl
      md:px-0
      md:shadow-none`
});

export const CondensedImageWrapper = createComponent('div', {
  className: 'relative h-[94px] w-[126px] shrink-0 md:h-[159px] md:w-[282px]'
});

export const SpinnerWrapper = createComponent('div', {
  className:
    'spinner-size-parent relative aspect-video h-full overflow-hidden sm:col-span-2 md:col-span-1 md:rounded-xl'
});
